import { jsx as _jsx } from "react/jsx-runtime";
import { createStylesContext } from '@chakra-ui/react';
const [TagInputStylesProvider, _useTagInputStyles] = createStylesContext('TagInput');
export const TagInputProvider = ({ children, styles, }) => {
    return (_jsx(TagInputStylesProvider, { value: styles, children: children }));
};
export const useTagInputStyles = _useTagInputStyles;
